import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import { fmtDateLong, fmtTime } from "../lib/format";
import { Icon } from "../components/icons";
import { EventAvailability } from "../components/EventAvailability";

export default function EventAvailabilityPage() {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const q = useQuery({ queryKey: ["event-availability", eventId], queryFn: () => api(`/events/${eventId}/availability`) });
  const ev = q.data?.event;
  return (
    <>
      <div className="page-header" style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <button className="icon-btn" onClick={() => navigate(-1)} data-testid="availability-back"><Icon name="chevron-back" size={22} /></button>
        <div style={{ flex: 1, minWidth: 0 }}>
          <h1 className="t-h1" style={{ fontSize: 24 }}>Disponibilidade</h1>
          {ev ? <div className="t-hint" data-testid="availability-event-title">{ev.title} · {fmtDateLong(ev.starts_at)} · {fmtTime(ev.starts_at)}</div> : null}
        </div>
      </div>
      <div className="page ulc-fade" style={{ maxWidth: 820 }}>
        <EventAvailability eventId={eventId} />
      </div>
    </>
  );
}
